import { Directive, Input, TemplateRef, ViewContainerRef, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appShowFor]'
})
export class ShowForDirective implements OnDestroy {
  private timer?: any;

  constructor(
    private tpl: TemplateRef<any>,
    private vcr: ViewContainerRef
  ) {}

  // Süre parametresi (default 5 saniye)
  @Input() appShowForSeconds = 5;

  // Tetikleme input'u
  @Input()
  set appShowForTrigger(value: any) {
    if (value) {
      this.show(this.appShowForSeconds);
    }
  }

  private show(seconds: number) {
    this.vcr.clear();
    this.vcr.createEmbeddedView(this.tpl);

    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => this.vcr.clear(), seconds * 1000);
  }

  ngOnDestroy() {
    if (this.timer) clearTimeout(this.timer);
  }
}
